export default __webpack_public_path__ + "static/O0133-ea7dc975faad882a4e5aa8fc5ca66d7c.png";